import { defineMessages } from 'react-intl-next';

export default defineMessages({
	unsupportedFrameComponentTitle: {
		id: 'forge-ui.common.extension.components.custom-field.view.unsupported-frame-component-title',
		defaultMessage: 'Frame not supported in view mode',
		description:
			'Title of the error message shown to app developer when they try to use UI Kit Frame component for rendering custom field in the view mode',
	},
	unsupportedFrameComponentDescription: {
		id: 'forge-ui.common.extension.components.custom-field.view.unsupported-frame-component-description',
		defaultMessage: 'Custom fields can’t render the Frame component in view mode.',
		description:
			'Description of the error message shown to app developer when they try to use UI Kit Frame component for rendering custom field in the view mode',
	},
});
